import axios from "../API/index";
import store from "../../store";

let randomUser = randomString();

//提取当前年级当前教材 数理化教材id
const getCatalogueIdList = function() {
  let idList = [];
  let teachingMaterial = store.state.User.teachingMaterial.data;
  teachingMaterial.forEach(item => {
    idList.push(item.id);
  });
  return idList;
};

//根据当前时间获取上下学期列表
const getSemesterCodeList = function() {
  let now = new Date();
  let currentMonth = now.getMonth() + 1;
  let semesterList = [];

  let teachingMaterial = store.state.User.teachingMaterial.data;
  teachingMaterial.forEach(item => {
    //下学期
    if (currentMonth >= 2 && currentMonth <= 7) {
      semesterList.push(
        item.fascicleList[0].childList[1]
          ? item.fascicleList[0].childList[1].id
          : item.fascicleList[0].childList[0].id
      );
    } else {
      semesterList.push(item.fascicleList[0].childList[0].id);
    }
  });
  return semesterList;
};
//

//获取知识标签
const labelKnowList = function(questionData) {
  if (!questionData) return;
  let knowlageLabelList = [];
  function getlabel(list) {
    list.forEach(item => {
      knowlageLabelList.push(item.name);
      if (item.childList.length > 0) {
        getlabel(item.childList);
      }
    });
  }
  if (questionData && questionData.examOptionList) {
    questionData.examOptionList.forEach(examItem => {
      for (const child of examItem.childList) {
        if (child.isMain) {
          getlabel(child.labelKnowList);
          break;
        }
      }
    });
  }
  if (!knowlageLabelList.length && questionData && questionData.examOptionLis) {
    getlabel(questionData.examOptionList[0].childList[0].labelKnowList);
  }

  return knowlageLabelList;
};

//用户行为上报
const updateUserBehavior = function(params) {
  // console.log("axios")
  if (!params.userId) {
    params.userId = randomUser;
  }
  axios
    .UserBehavior(params)
    .then(result => {
      // console.log("updateUserBehavior", params.behaviorParam.behaviorContent.elementTypeCode, params.behaviorParam.behaviorContent.elementId, result.success)
    })
    .catch(err => {});
};

//时间格式化
const formatTimer = function(time) {
  // 获取时分秒
  let h = parseInt(time / 3600);
  let m = parseInt((time - h * 3600) / 60);
  let s = parseInt(time - h * 3600 - m * 60);

  // 格式化
  h < 10 ? (h = `0${h}`) : "";
  m < 10 ? (m = `0${m}`) : "";
  s < 10 ? (s = `0${s}`) : "";

  // console.log(`${h}:${m}:${s}`)
  return h == 0 ? `${m}:${s}` : `${h}:${m}:${s}`;
};

//数字格式化
function numberConversion(val) {
  let nVal = ["", "", ""];
  let fr = 1000;
  let num = 3;
  while (val / fr >= 1) {
    fr *= 10;
    num += 1;
  }
  if (num <= 4) {
    // 千
    nVal[1] = "千";
    nVal[0] = parseInt(val / 1000) + "";
  } else if (num <= 8) {
    // 万
    const str = parseInt(num - 4) / 3 > 1 ? "千万" : "万";
    const fm = "万" === str ? 10000 : 10000000;
    nVal[1] = str;
    nVal[0] = (val / fm).toFixed(2) + "";
  } else if (num <= 16) {
    // 亿
    let str = (num - 8) / 3 > 1 ? "千亿" : "亿";
    str = (num - 8) / 4 > 1 ? "万亿" : str;
    str = (num - 8) / 7 > 1 ? "千万亿" : str;

    let fm = 1;
    if ("亿" === str) {
      fm = 100000000;
    } else if ("千亿" === str) {
      fm = 100000000000;
    } else if ("万亿" === str) {
      fm = 1000000000000;
    } else if ("千万亿" === str) {
      fm = 1000000000000000;
    }
    nVal[1] = str;
    nVal[0] = parseInt(val / fm) + "";
  }
  if (val < 1000) {
    nVal[1] = "";
    nVal[0] = val + "";
  }
  return nVal.join("");
}

function randomString(len) {
  len = len || 32;
  var $chars =
    "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678"; /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
  var maxPos = $chars.length;
  var pwd = "";
  for (let i = 0; i < len; i++) {
    pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
  }
  return pwd;
}

function IsMobile() {
  let userAgent = navigator.userAgent,
    Agents = [
      "Android",
      "iPhone",
      "SymbianOS",
      "Windows Phone",
      "iPad",
      "iPod"
    ];
  return Agents.some(i => {
    return userAgent.includes(i);
  });
}

//时间戳转时间
function transformTime(time = +new Date()) {
  console.log(date);

  var date = new Date(time + 8 * 3600 * 1000); // 增加8小时
  return date
    .toJSON()
    .substr(0, 19)
    .replace("T", " ");
}

//字节转换
function transformByte(limit) {
  var size = "";
  if (limit < 0.1 * 1024) {
    //小于0.1KB，则转化成B
    size = limit.toFixed(2) + "B";
  } else if (limit < 0.1 * 1024 * 1024) {
    //小于0.1MB，则转化成KB
    size = (limit / 1024).toFixed(2) + "KB";
  } else if (limit < 0.1 * 1024 * 1024 * 1024) {
    //小于0.1GB，则转化成MB
    size = (limit / (1024 * 1024)).toFixed(2) + "MB";
  } else {
    //其他转化成GB
    size = (limit / (1024 * 1024 * 1024)).toFixed(2) + "GB";
  }

  var sizeStr = size + ""; //转成字符串
  var index = sizeStr.indexOf("."); //获取小数点处的索引
  var dou = sizeStr.substr(index + 1, 2); //获取小数点后两位的值
  if (dou == "00") {
    //判断后两位是否为00，如果是则删除00
    return sizeStr.substring(0, index) + sizeStr.substr(index + 3, 2);
  }
  return size;
}

//节流函数
function throttle(fn, wait) {
  let lastTime = null;
  return function() {
    let nowTime = new Date();
    // console.log("nowtime----", nowTime, "   lastTime----", lastTime);
    let content = this;
    if (nowTime - lastTime >= wait) {
      lastTime = nowTime;
      fn();
    }
  };
}
function validTimeFormat(time) {
  // console.log(time);
  if (time == 0) {
    return "永久有效";
  }
  if (time < 24) {
    return time + "小时";
  }
  let day = parseInt(time / 24);
  let hour = time % 24;
  if (hour > 0) day++;
  return day + "天";
}
function copyTxt(text) {
  return new Promise((reslove, reject) => {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(text).then(
        function() {
          reslove("复制成功");
        },
        function() {
          copy2(text);
          reslove("复制成功");
        }
      );
    } else {
      copy2(text);
      reslove();
    }
  });
}

function copy2(text) {
  if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
    const range = document.createRange();
    range.selectNode(document.querySelector(".copyTxt"));
    const selection = window.getSelection();
    if (selection.rangeCount > 0) selection.removeAllRanges();
    selection.addRange(range);
    document.execCommand("Copy");
    // layer.msg("复制成功");
    selection.removeAllRanges();
  } else {
    const input = document.createElement("input");
    input.value = text;
    input.className = "";
    document.body.appendChild(input);
    input.select();
    if (document.execCommand("copy")) {
      document.execCommand("copy");
      // layer.msg("复制成功");
    }
    document.body.removeChild(input);
  }
}
export {
  copyTxt,
  validTimeFormat,
  updateUserBehavior,
  getCatalogueIdList,
  getSemesterCodeList,
  labelKnowList,
  formatTimer,
  numberConversion,
  randomString,
  IsMobile,
  transformTime,
  transformByte,
  throttle
};



// WEBPACK FOOTER //
// ./src/js/utils/common.js